import initialState from '../initialstate';
import * as types from '../../actions/actiontypes';

export default function DashboardPermissionsReducer(state = initialState.permissions, action) {
	switch (action.type) {
		case types.GET_PERMISSIONS: {
			return action.response;
		}
		default:
			return state;
	}
}
